<script setup lang="ts">
import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import type { LayoutSortingState } from '#layers/listing/types/layout';
import { computed } from 'vue';
import { CollectionFieldSelect } from '#layers/data-model/public';
import { SortFormField } from '#layers/ui/public';

defineProps<{
	collection: ResolvedMonospaceCollection;
}>();

const modelValue = defineModel<LayoutSortingState>({ default: () => [] });

// SortingState is an array, but we only support single-column sorting here
const sort = computed({
	get: () => modelValue.value?.[0],
	set: (value) => {
		if (value) {
			modelValue.value = [value];
		}
		else {
			modelValue.value = [];
		}
	},
});

const sortField = computed({
	get: () => sort.value?.fieldId ?? null,
	set: (value) => {
		if (value) {
			sort.value = { fieldId: value, direction: 'asc' };
		}
		else {
			sort.value = undefined;
		}
	},
});

const sortDirection = computed({
	get: () => sort.value?.direction ?? 'asc',
	set: (value) => {
		if (!sort.value) return;
		sort.value = { ...sort.value, direction: value };
	},
});
</script>

<template>
	<SortFormField
		v-model:direction="sortDirection"
		:show-toggle="!!sortField"
	>
		<template #field-select>
			<CollectionFieldSelect
				v-model="sortField"
				include-primitive-fields
				:collection
				:include-relation-fields="false"
				:include-constrained-fields="false"
				:clear="false"
				class="w-full"
			/>
		</template>
	</SortFormField>
</template>
